export default __webpack_public_path__ + "static/media/Header_Reset.34e9a9dd.png";